module.exports = __webpack_public_path__ + "static/media/vip-tab-active.98733bde.png";